// src/index.ts
import { join } from "node:path";
function getGitIgnoredFolder(projectFolder = "") {
  return join(projectFolder, ".wix");
}
function getTypesDir(projectFolder) {
  return join(getGitIgnoredFolder(projectFolder), "types");
}
function getPageTypesDir(projectFolder, pageId) {
  return join(getTypesDir(projectFolder), pageId);
}
function getPageConfigFilename(projectFolder, pageId) {
  return join(getPageTypesDir(projectFolder, pageId), `jsconfig.json`);
}
function getBackendConfigPath(projectFolder) {
  return join(getTypesDir(projectFolder), "backend", "jsconfig.json");
}
function getPublicConfigPath(projectFolder) {
  return join(getTypesDir(projectFolder), "public", "jsconfig.json");
}
function getSourceFolder(projectFolder) {
  return join(projectFolder, "src");
}
function getPagesFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "pages");
}
function getPublicFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "public");
}
function getBackendFolder(projectFolder = "") {
  return join(getSourceFolder(projectFolder), "backend");
}
function getPageCodeFilePath(projectFolder, page) {
  return join(
    getPagesFolder(projectFolder),
    `${[page.pageTitle, page.pageMetaData.pageId].filter(Boolean).join(".")}.js`
  );
}
var PAGE_FILENAME_PARTS_NUM = 3;
function isPageFilename(filename) {
  const parts = filename.split(".");
  if (parts.length !== PAGE_FILENAME_PARTS_NUM) {
    return false;
  }
  return true;
}
function getPageIdByFilename(filename) {
  if (!isPageFilename(filename)) {
    return void 0;
  }
  const parts = filename.split(".");
  return parts[1];
}
function doesFilenameMatchPageWithId(id, filename) {
  return getPageIdByFilename(filename) === id;
}
function getPageTitle(filename) {
  if (!isPageFilename(filename)) {
    return void 0;
  }
  const parts = filename.split(".");
  return parts[0];
}
export {
  doesFilenameMatchPageWithId,
  getBackendConfigPath,
  getBackendFolder,
  getGitIgnoredFolder,
  getPageCodeFilePath,
  getPageConfigFilename,
  getPageIdByFilename,
  getPageTitle,
  getPageTypesDir,
  getPagesFolder,
  getPublicConfigPath,
  getPublicFolder,
  getSourceFolder,
  getTypesDir
};
